import { render, staticRenderFns } from "./editPane.vue?vue&type=template&id=28003296"
import script from "./editPane.vue?vue&type=script&lang=js"
export * from "./editPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports